import { useSwipeable } from 'react-swipeable';
import React, { useEffect, useState } from 'react';
import styles from './DownloadAppCarousel.module.css';

interface DownloadAppCarouselProps {
  images: string[];
  currentIndex: number;
  onIndexChange: (index: number) => void;
}

const DownloadAppCarousel: React.FC<DownloadAppCarouselProps> = ({
  images,
  currentIndex,
  onIndexChange,
}) => {
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handlers = useSwipeable({
    onSwipedLeft: () => onIndexChange(currentIndex + 1),
    onSwipedRight: () => onIndexChange(currentIndex - 1),
    trackMouse: true,
    preventScrollOnSwipe: true,
  });

  useEffect(() => {
    if (currentIndex === images.length || currentIndex < 0) {
      const timer = setTimeout(() => {
        setIsTransitioning(true);
        if (currentIndex === images.length) {
          onIndexChange(0);
        } else {
          onIndexChange(images.length - 1);
        }
      }, 500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [currentIndex, images.length, onIndexChange]);

  useEffect(() => {
    if (isTransitioning) {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
      }, 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isTransitioning]);

  const displayedImages = [images[images.length - 1], ...images, images[0]];

  return (
    <div {...handlers} className={styles.carouselContainer}>
      <div
        className={styles.carouselTrack}
        style={{
          transform: `translateX(-${(currentIndex + 1) * 100}%)`,
          transition: !isTransitioning ? 'transform 0.5s ease-in-out' : 'none',
        }}
      >
        {displayedImages.map((image, index) => (
          <div className={styles.carouselSlide} key={index}>
            <img
              src={image}
              alt={`Feature ${index + 1}`}
              className={styles.carouselImage}
              draggable="false"
            />
          </div>
        ))}
      </div>
      <div className={styles.dotsContainer}>
        {images.map((_, index) => (
          <div
            key={index}
            className={`${styles.dot} ${
              index === currentIndex % images.length ? styles.activeDot : ''
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default DownloadAppCarousel;
